import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import * as AppStoreSelectors from 'apps/federation/src/app/root-store/app-store/selectors';
import { AppStoreActions } from 'apps/federation/src/app/root-store/app-store';
import { getResolvedUrl } from '@aston/foundation';

@Injectable({
	providedIn: 'root'
})
export class IsSupportGuard implements CanActivate {
	private router = inject(Router);
	private store = inject(Store);


	canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
		return this.store.pipe(
			select(AppStoreSelectors.selectCurrentUserIsSupport),
			map(allowed => {
				// TODO: Dispatch an action to show a permission denied modal here
				if (!allowed && next.data.redirectUrl) {
					// if the redirect url is also disallowed
					if (next.data.redirectUrl === getResolvedUrl(next)) {
						this.store.dispatch(AppStoreActions.NotFound({ message: 'Errors.NotFound' }))
					} else {
						this.router.navigate([next.data.redirectUrl]);
					}
				}
				return !!allowed;
			}),
			first()
		);
	}
}
